import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrModule } from 'ngx-toastr';
import { HighlightCodeModule } from 'src/app/candidate/pipes/highlight-code/highlight-code.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CreateUpdateCodingQuesComponent } from './create-update-coding-ques/create-update-coding-ques.component';
import { CreateUpdateMcqComponent } from './create-update-mcq/create-update-mcq.component';
import { CreateUpdateOeqComponent } from './create-update-oeq/create-update-oeq.component';
import { GenerateLoaderComponent } from './generate-loader/generate-loader.component';
import { McqsListComponent } from './mcqs-list/mcqs-list.component';
import { OeqsListComponent } from './oeqs-list/oeqs-list.component';
import { QuestionFiltersComponent } from './question-filters/question-filters.component';
import { QuestionsListContainerComponent } from './questions-list-container/questions-list-container.component';
import { QuestionsPreviewComponent } from './questions-preview/questions-preview.component';
import { SelectedCqsListComponent } from './selected-cqs-list/selected-cqs-list.component';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { CqsListComponent } from './cqs-list/cqs-list.component';
import { UndoComponent } from './undo/undo.component';
import { NewlineToBrPipe } from '../../pipes/newline-to-br.pipe';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { StringsPipe } from '../../pipes/strings.pipe';
import { QuestionContentComponent } from './question-content/question-content.component';
import { DifficultyLevelPipe } from '../../pipes/difficulty-level.pipe';

@NgModule({
  declarations: [
    QuestionFiltersComponent,
    QuestionsPreviewComponent,
    CreateUpdateMcqComponent,
    CreateUpdateOeqComponent,
    CreateUpdateCodingQuesComponent,
    SelectedCqsListComponent,
    SnackbarComponent,
    McqsListComponent,
    QuestionsListContainerComponent,
    OeqsListComponent,
    GenerateLoaderComponent,
    CqsListComponent,
    UndoComponent,
    NewlineToBrPipe,
    SafeHtmlPipe,
    StringsPipe,
    QuestionContentComponent,
    DifficultyLevelPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    HighlightCodeModule,
    NgMultiSelectDropDownModule.forRoot(),
    ToastrModule.forRoot()
  ],
  exports: [
    QuestionFiltersComponent,
    QuestionsPreviewComponent,
    SelectedCqsListComponent,
    HighlightCodeModule,
    QuestionsListContainerComponent,
    McqsListComponent,
    OeqsListComponent,
    CqsListComponent,
    GenerateLoaderComponent,
    DifficultyLevelPipe
  ]
})

export class CustomCommonModule { }
